/* global axios */
import ApiClient from './ApiClient';

class ScheduledMessagesAPI extends ApiClient {
  constructor() {
    super('scheduled_messages', { accountScoped: true });
  }

  get({ page = 1 } = {}) {
    return axios.get(this.url, { params: { page } });
  }

  create(conversationId, data) {
    return axios.post(
      `${this.baseUrl()}/conversations/${conversationId}/scheduled_messages`,
      { scheduled_message: data }
    );
  }

  getByConversation(conversationId) {
    return axios.get(
      `${this.baseUrl()}/conversations/${conversationId}/scheduled_messages`
    );
  }

  update(conversationId, id, data) {
    return axios.patch(
      `${this.baseUrl()}/conversations/${conversationId}/scheduled_messages/${id}`,
      { scheduled_message: data }
    );
  }

  cancel(conversationId, id) {
    return axios.delete(
      `${this.baseUrl()}/conversations/${conversationId}/scheduled_messages/${id}`
    );
  }

  retry(conversationId, id) {
    return axios.post(
      `${this.baseUrl()}/conversations/${conversationId}/scheduled_messages/${id}/retry`
    );
  }
}

export default new ScheduledMessagesAPI();
